// extracted by mini-css-extract-plugin
export default {"branddropdown":"DropdownBase_branddropdown__Vy64U"};